// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_ae1ee421","noStockAvailable":"rdg_fa021d9b","old":"rdg_dd43ecf8","discount":"rdg_f07e4b6e"};